document.addEventListener('DOMContentLoaded', () => {
    function initHeroCarousel() {
        if (typeof EmblaCarousel === 'undefined') {
            setTimeout(initHeroCarousel, 100);
            return;
        }

        const heroBanners = document.querySelectorAll('.hero-banner.embla');

        heroBanners.forEach((heroBanner) => {
            const viewport = heroBanner.querySelector('.embla__viewport');
            const dotsContainer = heroBanner.querySelector('.embla__dots');

            if (!viewport) return;

            const autoChangeSeconds = parseInt(heroBanner.dataset.autoChangeSeconds, 10) || 0;
            const autoplayEnabled = autoChangeSeconds > 0;

            const embla = EmblaCarousel(viewport, {
                loop: autoplayEnabled,
            });

            if (autoplayEnabled) {
                setInterval(() => embla.scrollNext(), autoChangeSeconds * 1000);
            }

            if (!dotsContainer) {
                embla.on('select', () => { });
                return;
            }

            const slides = embla.scrollSnapList();
            const dots = [];

            slides.forEach((_, index) => {
                const dot = document.createElement('button');
                dot.className = 'embla__dot';
                dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
                dot.addEventListener('click', () => embla.scrollTo(index));
                dotsContainer.appendChild(dot);
                dots.push(dot);
            });

            const updateDots = () => {
                const selectedIndex = embla.selectedScrollSnap();
                dots.forEach((dot, index) => {
                    dot.classList.toggle('embla__dot--active', index === selectedIndex);
                });
            };

            embla.on('select', updateDots);
            updateDots();
        });
    }

    initHeroCarousel();
});
